module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABZ0lEQVQ4je2VvUoDURCFPzXZiCKIP4WipFDQwkI7n8BHsFKsBd9B8BH0DXwCbS3ttAgWgl1QQSsF0SRoTFRGzg2XMbtZ0NIDl92ZOffMzN6fJQWbwGeOcdRtel8X3zjwAFwDx2lZgVFgC9gDdjN435hShfO9iMArcOqdBWARWFHVbWBBsW3gDBjoImZJP4ASMAOsi2caT0Y4zPn9cg9THlPL9n4HNIFZZW4BN7JLqvIWKGqOxevAI1BW5w3fliWYdr45Z9tCjjhfOevDV9ViwKrstcj3DlQie0ecpeDod6JNZ4eWB52/Hb0neg6nib5pBLSi6gIajtP0HC/6J/gXzURRwSQi2R4d+o1oOB21yFdzq/8DhR6iFV02l5FvOdpquUQTd6Js8oXjVJ1d17Nzm/n2LRBOUV5Mitg5Zb7SA2Bfl+9zyp8hwDqy+ARwD1zFlcU41yVr2W0xTPglZdiCWfwE2NAvCIAvUYVmDCXo/SUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/del.png
// module id = stew
// module chunks = 1